var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/brand/brand-footer-copy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"brandNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"));
frame.set("categoryBrand", t_1, true);
if(frame.topLevel) {
context.setVariable("categoryBrand", t_1);
}
if(frame.topLevel) {
context.addExport("categoryBrand", t_1);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "categoryBrand") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"displayName")) {
output += "\n\n    ";
var t_2;
t_2 = "category_brand-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"slug") + "" + "-seo-footer-copy";
frame.set("brandFooterSlug", t_2, true);
if(frame.topLevel) {
context.setVariable("brandFooterSlug", t_2);
}
if(frame.topLevel) {
context.addExport("brandFooterSlug", t_2);
}
output += "\n    ";
var t_3;
t_3 = "category_brand-default-seo-footer-copy";
frame.set("brandFooterSlugDefault", t_3, true);
if(frame.topLevel) {
context.setVariable("brandFooterSlugDefault", t_3);
}
if(frame.topLevel) {
context.addExport("brandFooterSlugDefault", t_3);
}
output += "\n    ";
var t_4;
t_4 = (lineno = 8, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "brandFooterSlug"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"slug"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteName")],"defaultSlug": runtime.contextOrFrameLookup(context, frame, "brandFooterSlugDefault")})]));
frame.set("brandFooterText", t_4, true);
if(frame.topLevel) {
context.setVariable("brandFooterText", t_4);
}
if(frame.topLevel) {
context.addExport("brandFooterText", t_4);
}
if(!runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "brandFooterText"),["{" + "" + runtime.contextOrFrameLookup(context, frame, "brandFooterSlug") + "" + "}","{" + "" + runtime.contextOrFrameLookup(context, frame, "brandFooterSlugDefault") + "" + "}",""])) {
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--offset-3 o-medium--9 o-large--offset-2 o-large--10\">\n\n                <div class=\"s-cms c-brand-footer\">\n\n                    <hr class=\"c-brand-footer__hr\" />\n\n                        ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.contextOrFrameLookup(context, frame, "brandFooterText")), env.opts.autoescape);
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n    ";
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/brand/brand-footer-copy.j2"] , dependencies)